// Used in video gallery 
// REQUIRES localizedvideo.js file

const infoVideos4i = function(){
	const LocalizedVideos = new localizedVideos4i();
	let player;

	const initWhyBuy = async (startPlayback = false) => {
		// NOTE: why buy ID is also stored in locale key: infopages > whybuyfromus
            	const whyBuyID = "a1488d91-3d14-4ce8-9543-8439211b2a72";
            	
            	var source = {
		        title: 'Be certain with 4imprint',
		        dash: 'https://cdnv.4imprint.com/encoded/' + whyBuyID + '/stream.mpd',
		        hls: 'https://cdnv.4imprint.com/encoded/' + whyBuyID + '/index.m3u8',
		        subtitleTracks: [{
		            url: 'https://cdn.4imprint.com/vid/captions/' + whyBuyID + '.vtt',
		            id: 'track-0',
		            label: 'English',
            			lang: 'en'
		        }],
		        thumbnailTrack: {
		            url: 'https://cdnv.4imprint.com/encoded/' + whyBuyID + '/sprites/low/sprite.vtt'
		        },
		        poster: 'https://cdn.4imprint.com/qtz/video/2016/vidthumb-shadow-lg.jpg'
		  };
            	
            	await playVideo(source, LocalizedVideos.WhyBuyVideoAnalyticsTitle, whyBuyID, startPlayback); 
     	};

	const initMugImprint = async (startPlayback = false) => {
		var source = {
		        title: LocalizedVideos.VideoTitle,
		        dash: 'https://cdnv.4imprint.com/encoded/' + LocalizedVideos.MugImprintID + '/stream.mpd',
		        hls: 'https://cdnv.4imprint.com/encoded/' + LocalizedVideos.MugImprintID + '/index.m3u8',
		        subtitleTracks: [{
		            url: LocalizedVideos.MugImprintCaptionURL,
		            id: 'track-0',
		            label: 'English',
            			lang: 'en'
		        }],
		        thumbnailTrack: {
		            url: 'https://cdnv.4imprint.com/encoded/' + LocalizedVideos.MugImprintID + '/sprites/low/sprite.vtt'
		        }
		  };
		
            	await playVideo(source, LocalizedVideos.VideoAnalyticsTitle, LocalizedVideos.MugImprintID, startPlayback);            		
	};
	
	const playVideo = async (playVidSourceConfig, playVidTitle, playVidID, startPlayback) =>{
	       var playerConfig = {
		        key: 'a8072f85-5072-454b-b8f2-09087b192aa7',
		        analytics: {
		            key: '26a9da30-39dd-4906-bf18-2b222b809d92',
		            title: playVidTitle,
		            videoId: playVidID,
		        },
		    };
	       if(player) await player.destroy();
	       player = new bitmovin.player.Player(document.getElementById("player"), playerConfig);
    		await player.load(playVidSourceConfig);
    		await getTranscript(playVidID);
    		if(startPlayback) player.play(); // seems like if the page loads with autoplay set to false, it ignores that on any other videos and you need to call play()
	};
	
	const getTranscript = async (videoID) =>{
		const url = "/video/Transcript/" + videoID;	
		const transcriptContainer = document.getElementById("transcriptContainer");
		const errorText = '<p class="text16">Oops, looks like there was either a problem getting the transcript or we may not have one completed yet.</p>';
		
		fetch(url, { 
			method: 'GET', 
			headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
		}).then(function(response){
			return  (response.ok) ? response.json() : []; // response.json() returns a promise
		}).then(function(response){
			if(response.transcripttext !== "") transcriptContainer.innerHTML =  '<p class="text16">' + response.transcripttext + '</p>';
			else transcriptContainer.innerHTML = errorText;
		}).catch(function(error){
			transcriptContainer.innerHTML = errorText;
		});
	};
	
	return{
		InitWhyBuy: initWhyBuy,
		InitMugImprint: initMugImprint
	};
};